import React from "react";
import { Link } from "react-router-dom";
import AddForm from "../components/AddForm";
import LogOut from "../components/LogOut";

const Add = () => {
  return (
    <div>
      <div className="navbar_admin">
      <LogOut />
        <h2>لوحة التحكم في حسابات العملاء</h2>
        <button className="add1">
          <Link to="/admin">العودة للرئيسية</Link>
        </button>
      </div>
      <div className="admin_area">
        <AddForm />
      </div>
    </div>
  );
};

export default Add;
